import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';


import { ChooseStudyTypeModalPage } from './choose-study-type-modal.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule  ],
  declarations: [ChooseStudyTypeModalPage]
})
export class ChooseStudyTypeModalPageModule {}
